var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_522_17816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.13232,
    y: 6.13232,
    width: 20.7354,
    height: 20.7354,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_522_17816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5386 19.9992C10.2218 19.452 9.98425 18.8904 9.82585 18.3144C9.66745 17.7384 9.58826 17.1481 9.58826 16.5433C9.58826 14.6137 10.2578 12.9722 11.597 11.6186C12.9362 10.265 14.5705 9.58827 16.5001 9.58827H16.6513L15.2689 8.20591L16.4785 6.99634L19.9344 10.4522L16.4785 13.9082L15.2689 12.6986L16.6513 11.3162H16.5001C15.0601 11.3162 13.8361 11.8237 12.8282 12.8385C11.8202 13.854 11.3162 15.0889 11.3162 16.5433C11.3162 16.9177 11.3594 17.2849 11.4458 17.6448C11.5322 18.0048 11.6618 18.3576 11.8346 18.7032L10.5386 19.9992ZM16.5217 26.0038L13.0658 22.5479L16.5217 19.092L17.7312 20.3016L16.3489 21.6839H16.5001C17.94 21.6839 19.164 21.1765 20.172 20.1616C21.1799 19.1462 21.6839 17.9112 21.6839 16.4569C21.6839 16.0825 21.6407 15.7153 21.5543 15.3553C21.4679 14.9953 21.3383 14.6425 21.1655 14.2969L22.4615 13.001C22.7783 13.5482 23.0159 14.1097 23.1743 14.6857C23.3327 15.2617 23.4119 15.8521 23.4119 16.4569C23.4119 18.3864 22.7423 20.028 21.4031 21.3815C20.064 22.7351 18.4296 23.4119 16.5001 23.4119H16.3489L17.7312 24.7943L16.5217 26.0038Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.49ac1a4be472aabd32268ef0dd081369.svg";
export { ForwardRef as ReactComponent };